import { prependProxyBaseUrl, request } from "api/request";
import type { ContextCoordinates } from "types/contextCoordinates";

const COORDINATES_ENDPOINT = prependProxyBaseUrl("/api/contents/context-coordinates");

export async function getCoordinatesByAnswerAndContent(answerId: string, metadataId: string): Promise<ContextCoordinates[]> {
  return await request().url(`${COORDINATES_ENDPOINT}/${answerId}/${metadataId}`).get().json();
}
